import { useState } from "react";

const Google_Popup_Number=({closePop,handleNumber,numberError,googleAddnumber})=>{





    return(
        <>
        <div className="modal">
      
        
        <div style={{padding:"5%",marginTop:"20%"}}>

              <div style={{background:"white",widows:"100%" ,height:"399px",borderRadius:"10px"}}>

              <div style={{display:"flex",justifyContent:"center",position: "relative",
    top:"-35px"}}>
      
      <svg xmlns="http://www.w3.org/2000/svg" width="142" height="66" viewBox="0 0 142 66" fill="none">
<g clip-path="url(#clip0_61_2282)">
<rect width="142" height="66" rx="33" fill="white"/>
<path d="M112.017 21.564C109.527 21.564 107.503 23.6012 107.503 26.1084V30.5345H116.54V26.1084C116.54 23.6012 114.506 21.564 112.017 21.564Z" fill="#029646"/>
<path d="M124.558 0H17.4418C7.85532 0 0 7.88827 0 17.5076V48.3694C0 58.0039 7.85532 65.877 17.4418 65.877H124.558C134.145 65.877 142 58.0039 142 48.3694V17.5076C142 7.88827 134.145 0 124.558 0ZM37.9472 37.7194L42.1317 42.291L34.8837 47.748L31.9107 42.291C31.4726 41.5119 30.7868 39.984 29.823 37.7194C28.7686 40.2083 28.0677 41.7241 27.7202 42.291L24.705 47.748L17.2545 42.291L21.7592 37.7194C23.0282 36.4613 24.2578 35.382 25.4724 34.4968C24.2337 34.3846 22.6052 34.1542 20.596 33.7752L14.3571 32.7566L17.2515 24.2317L22.8469 26.7843C23.436 27.0511 24.9014 27.8909 27.2338 29.2824C26.7353 27.0178 26.415 25.3352 26.27 24.2317L25.4754 18.1291H34.361L33.6419 24.2317C33.4848 25.7172 33.1404 27.3998 32.6298 29.2824C33.654 28.767 34.3308 28.4244 34.651 28.2365C35.7749 27.6089 36.642 27.1754 37.2251 26.8965L42.8236 24.2317L45.5971 32.7566L39.4065 34.0541C38.2735 34.2724 36.5937 34.4149 34.361 34.4968C35.8746 35.6852 37.059 36.7523 37.9472 37.7194ZM78.9671 37.7194L83.1576 42.291L75.9096 47.7449L72.9397 42.291C72.5016 41.5119 71.8158 39.984 70.855 37.7194C69.7975 40.2083 69.1026 41.7241 68.7552 42.291L65.7339 47.7449L58.2865 42.291L62.7912 37.7194C64.0601 36.4613 65.2868 35.382 66.5043 34.4968C65.2717 34.3846 63.6371 34.1542 61.628 33.7752L55.386 32.7566L58.2835 24.2317L63.8819 26.7843C64.465 27.0511 65.9363 27.8909 68.2657 29.2824C67.7551 27.0178 67.4349 25.3352 67.2989 24.2317L66.5013 18.1351H75.3899L74.6678 24.2317C74.5047 25.7172 74.1663 27.3998 73.6617 29.2824C74.6799 28.767 75.3567 28.4244 75.68 28.2365C76.7978 27.6089 77.668 27.1754 78.2541 26.8965L83.8555 24.2317L86.6321 32.7566L80.4354 34.0541C79.3025 34.2724 77.6287 34.4149 75.3929 34.4968C76.8945 35.6852 78.0819 36.7523 78.9671 37.7194ZM124.93 45.4439C124.93 47.3205 123.398 48.8545 121.531 48.8545H102.512C100.642 48.8545 99.113 47.3205 99.113 45.4439V33.942C99.113 32.0654 100.642 30.5314 102.512 30.5314H102.971V26.1053C102.971 21.094 107.029 17.0165 112.017 17.0165C117.008 17.0165 121.069 21.091 121.069 26.1053V30.5314H121.528C123.392 30.5314 124.927 32.0654 124.927 33.942L124.93 45.4439Z" fill="#029646"/>
</g>
<defs>
<clipPath id="clip0_61_2282">
<rect width="142" height="66" rx="33" fill="white"/>
</clipPath>
</defs>
</svg>
   </div>

<div style={{position:"relative",top:"-21px",textAlign:"center",padding:"5%"}}>



<h1 style={{fontSize:"20px",fontWeight:"700"}}>Enter OTP</h1>
<p style={{fontSize:"14px",fontWeight:"400",marginTop:"5%"}}>Enter the 4-digit code sent to your number 8586028020.</p>

<div style={{border:"2px solid #8080805e",borderRadius:"10px",marginTop:"7%"}}>
  <input  style={{padding:"2%",paddingLeft:"0%", fontSize:"20px",marginLeft:"0px",}} type="number"  
  onChange={(e)=>{handleNumber(e)}}
  placeholder="Please enter the OTP" />
</div>
{numberError&&<p style={{color:"rgba(234, 67, 53, 1)",textAlign:"start",marginTop:"3%"}}  > Didn’t receive code? Resend in 30s</p>}

<div style={{display:"flex",    justifyContent:"space-between",    marginTop:"15%"}}>
    <button style={{    padding:" 5%",
    width: "132px",
    border: "2px solid rgba(0, 177, 119, 1)",
    textAlign: "center",
    borderRadius: "10px",color:"rgba(0, 177, 119, 1)"}} onClick={(e)=>closePop(e)}>
    Cancel
    </button>

    <button  onClick={googleAddnumber} style={{    padding:" 5%",
    width: "131px",
   
    textAlign: "center",
    borderRadius: "10px",background:" rgba(0, 177, 119, 1)",fontSize:"15px",fontWeight:"700",color:"white"}}>
    SUBMIT
    </button>
</div>

</div>



              </div>
        
           
            </div>
            </div>
            </>
    )
}

export default Google_Popup_Number;